import { useState, useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AboutPage() {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      const res = await fetch(`${API}/about`);
      if (res.ok) {
        setAbout(await res.json());
      }
    } catch (e) {
      console.error("Error fetching about:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper" data-testid="about-page">
      <div className="myspace-container max-w-3xl">
        {/* Header */}
        <div className="myspace-header">
          <h3>about kezzio</h3>
        </div>

        <div className="myspace-section m-2">
          <div className="myspace-section-title">:: {about?.title || "About Me"} ::</div>
          <div className="myspace-section-content">
            {loading ? (
              <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-4">
                Loading...
              </div>
            ) : about ? (
              <div className="flex flex-col md:flex-row gap-6 items-start">
                {/* Photo */}
                {about.photo_url && (
                  <div className="flex-shrink-0">
                    <img
                      src={about.photo_url}
                      alt="Kezzio"
                      className="w-48 h-48 object-cover border-2 border-[var(--border-color)]"
                    />
                  </div>
                )}

                {/* Bio */}
                <div className="flex-1">
                  <div className="text-[11px] text-[var(--text-white)] opacity-80 leading-relaxed whitespace-pre-wrap">
                    {about.content}
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-4">
                About info coming soon!
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-[10px] text-[var(--text-white)] opacity-50 py-3 border-t border-[var(--border-color)]">
          <a href="/" className="text-[var(--text-link)]">&laquo; Back to Home</a>
        </div>
      </div>
    </div>
  );
}
